export default __webpack_public_path__ + "static/media/dev-api.c5b158f2.webp";